export enum PlatformStatus {
  PENDING = 'PENDING',
  JOINED = 'JOINED',
  ISSUES = 'ISSUES'
}

export enum OnboardingStatus {
  INCOMPLETE = 'INCOMPLETE',
  FORM_COMPLETED = 'FORM_COMPLETED',
  SETUP_COMPLETED = 'SETUP_COMPLETED'
}

export enum OfferStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  ONBOARDING = 'ONBOARDING',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED'
}

export enum ApplicantStatus {
  APPLIED = 'APPLIED',
  IN_REVIEW = 'IN_REVIEW',
  SAMPLE_REQUESTED = 'SAMPLE_REQUESTED',
  OFFER_SENT = 'OFFER_SENT',
  REJECTED = 'REJECTED'
}

export enum RatingStatus {
  UNRATED = 'UNRATED',
  RATED = 'RATED'
}

export enum OrgRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER'
}

export enum CreatorStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED'
}

export enum SubscriptionPlan {
  FREE = 'FREE',
  PRO = 'PRO',
  ENTERPRISE = 'ENTERPRISE'
}

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  CANCELED = 'CANCELED',
  TRIALING = 'TRIALING',
  EXPIRED = 'EXPIRED',
  PAUSED = 'PAUSED'
}

export enum MemberStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED'
}

export enum Permission {
  MANAGE_BRAND = 'MANAGE_BRAND',
  MANAGE_MEMBERS = 'MANAGE_MEMBERS',
  MANAGE_CREATORS = 'MANAGE_CREATORS',
  VIEW_ANALYTICS = 'VIEW_ANALYTICS',
  MANAGE_BILLING = 'MANAGE_BILLING'
}

export enum OrgPermission {
  MANAGE_ORGANIZATION = 'MANAGE_ORGANIZATION',
  MANAGE_BRANDS = 'MANAGE_BRANDS',
  MANAGE_BILLING = 'MANAGE_BILLING',
  MANAGE_MEMBERS = 'MANAGE_MEMBERS',
  VIEW_ALL_ANALYTICS = 'VIEW_ALL_ANALYTICS'
}